/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLocationRequestSubscription
 */
export interface CreateLocationRequestSubscription {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestSubscription
     */
    locationPlan?: CreateLocationRequestSubscriptionLocationPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestSubscription
     */
    reservationsPlan?: CreateLocationRequestSubscriptionReservationsPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestSubscription
     */
    paymentFrequency: CreateLocationRequestSubscriptionPaymentFrequencyEnum;
}


/**
 * @export
 */
export const CreateLocationRequestSubscriptionLocationPlanEnum = {
    Starter: 'starter',
    Growth: 'growth',
    Unlimited: 'unlimited'
} as const;
export type CreateLocationRequestSubscriptionLocationPlanEnum = typeof CreateLocationRequestSubscriptionLocationPlanEnum[keyof typeof CreateLocationRequestSubscriptionLocationPlanEnum];

/**
 * @export
 */
export const CreateLocationRequestSubscriptionReservationsPlanEnum = {
    Basic: 'basic',
    Core: 'core',
    Premium: 'premium'
} as const;
export type CreateLocationRequestSubscriptionReservationsPlanEnum = typeof CreateLocationRequestSubscriptionReservationsPlanEnum[keyof typeof CreateLocationRequestSubscriptionReservationsPlanEnum];

/**
 * @export
 */
export const CreateLocationRequestSubscriptionPaymentFrequencyEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type CreateLocationRequestSubscriptionPaymentFrequencyEnum = typeof CreateLocationRequestSubscriptionPaymentFrequencyEnum[keyof typeof CreateLocationRequestSubscriptionPaymentFrequencyEnum];


/**
 * Check if a given object implements the CreateLocationRequestSubscription interface.
 */
export function instanceOfCreateLocationRequestSubscription(value: object): value is CreateLocationRequestSubscription {
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    return true;
}

export function CreateLocationRequestSubscriptionFromJSON(json: any): CreateLocationRequestSubscription {
    return CreateLocationRequestSubscriptionFromJSONTyped(json, false);
}

export function CreateLocationRequestSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLocationRequestSubscription {
    if (json == null) {
        return json;
    }
    return {
        
        'locationPlan': json['locationPlan'] == null ? undefined : json['locationPlan'],
        'reservationsPlan': json['reservationsPlan'] == null ? undefined : json['reservationsPlan'],
        'paymentFrequency': json['paymentFrequency'],
    };
}

export function CreateLocationRequestSubscriptionToJSON(json: any): CreateLocationRequestSubscription {
    return CreateLocationRequestSubscriptionToJSONTyped(json, false);
}

export function CreateLocationRequestSubscriptionToJSONTyped(value?: CreateLocationRequestSubscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationPlan': value['locationPlan'],
        'reservationsPlan': value['reservationsPlan'],
        'paymentFrequency': value['paymentFrequency'],
    };
}

